import { Injectable } from "@angular/core";
import { Router } from "@angular/router";

@Injectable({ providedIn: 'root' })
export class AuthSyncService {
    private channel = new BroadcastChannel('auth_channel');

    constructor(private router: Router) {
        // listen for requests and session-token broadcasts
        this.channel.onmessage = (event) => {
            switch (event.data?.type) {
                case 'REQUEST_SESSION_TOKEN':
                    this.respondWithSession();
                    break;
                case 'SESSION_TOKEN':
                    this.receiveSession(event.data);
                    break;
                case 'LOGOUT':
                    this.clearSession();
                    break;
            }
        };
    }

    /** Called on app init in each tab to ask others for their tokens */
    requestSessionTokenFromOtherTabs() {
        this.channel.postMessage({ type: 'REQUEST_SESSION_TOKEN' });
    }

    /** Called by other tabs upon receiving REQUEST_SESSION_TOKEN */
    private respondWithSession() {
        const token = sessionStorage.getItem('accessToken');
        const refreshToken = sessionStorage.getItem('refreshToken');
        const expireAt = sessionStorage.getItem('expireAt');
        if (token) {
            this.channel.postMessage({
                type: 'SESSION_TOKEN',
                token,
                refreshToken,
                expireAt
            });
        }
    }

    /** When another tab shares its session, adopt it */
    private receiveSession(data: any) {
        if (!sessionStorage.getItem('accessToken')) {
            sessionStorage.setItem('accessToken', data.token);
            sessionStorage.setItem('refreshToken', data.refreshToken);
            sessionStorage.setItem('expireAt', data.expireAt);
            location.reload();   // re-bootstrap with session
        }
    }

    /** Initiates a logout across all tabs */
    logoutAllTabs() {
        // Clear local session then notify others
        this.clearSession();
        this.channel.postMessage({ type: 'LOGOUT' });
    }

    /** Clears tokens from sessionStorage and redirects to login */
    private clearSession() {
        sessionStorage.removeItem('accessToken');
        sessionStorage.removeItem('refreshToken');
        sessionStorage.removeItem('expireAt');
        // Optionally navigate to login or reload
        this.router.navigate(['/auth/login']);
    }
}
